// extracted by mini-css-extract-plugin
export var filterIncDec = "_5b-0";
export var leftBorder = "_5b-1";
export var rightBorder = "_5b-2";
export var stringInput = "_5b-3";